import { render } from "./CounterpartiesModal.vue?vue&type=template&id=4c164310&ts=true"
import script from "./CounterpartiesModal.vue?vue&type=script&lang=ts"
export * from "./CounterpartiesModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__